interface ExternalBadge {
  href: string
  imgSrc: string
  alt: string
  width: number
  height: number
  rel?: string
}

// バッジを追加するときはこの配列に追記するだけでよい
const BADGES: ExternalBadge[] = [
  {
    href: 'https://postyourstartup.co/startup/scenariomock?ref=badge',
    imgSrc: 'https://postyourstartup.co/api/badge/scenariomock?theme=light',
    alt: 'Featured on PostYourStartup',
    width: 212,
    height: 55,
  },
  {
    href: 'https://www.producthunt.com/products/scenariomock?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-scenariomock',
    imgSrc: 'https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1196177&theme=light&t=1784160879039',
    alt: 'ScenarioMock - Stateful Mock API server you can share with a single URL | Product Hunt',
    width: 250,
    height: 54,
    rel: 'noopener noreferrer',
  },
]

export function BadgeStrip() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-4">
      {BADGES.map((badge) => (
        <a
          key={badge.href}
          href={badge.href}
          target="_blank"
          rel={badge.rel ?? 'noopener noreferrer'}
        >
          <img
            src={badge.imgSrc}
            alt={badge.alt}
            width={badge.width}
            height={badge.height}
          />
        </a>
      ))}
    </div>
  )
}
